import { createBuilderModule } from '../../builder';
import { LottieAnimation } from './LottieAnimation';

export default createBuilderModule(LottieAnimation, {
  name: 'LottieAnimation',
  image: 'https://cdn.zappy.app/2ae06f8d25de1dba595553702ffc57f8.svg',
  inputs: [
    {
      name: 'animationDataUrl',
      type: 'cloudinaryMediaLibrary',
      required: true,
    },
    {
      name: 'animationAssetsUrl',
      type: 'string',
    },
    {
      name: 'autoplay',
      type: 'boolean',
    },
    {
      name: 'loop',
      type: 'boolean',
    },
    {
      name: 'speed',
      type: 'number',
    },
    {
      name: 'ariaLabel',
      type: 'string',
    },
  ],
});
